// 덴클 프로그램(에이전트 v2) 최신 배포 버전 — 릴리즈 때 AgentDownload.js 링크와 함께 이 값을 갱신한다.
// 사이드메뉴 '업데이트' 배지(MainLayout)와 다운로드 페이지 안내가 이 값 하나를 본다 (2026-08-25 대표 지시).
export const LATEST_AGENT_BUILD = '1.0.0-alpha.126';

// '1.0.0-alpha.41' / '0.9.46' 형태를 [major, minor, patch, alphaN]으로 — alpha 없는 정식판은 alphaN=Infinity
function parseBuild(v) {
    const m = String(v || '').trim().match(/^(\d+)\.(\d+)\.(\d+)(?:-alpha\.(\d+))?$/);
    if (!m) return null;
    return [Number(m[1]), Number(m[2]), Number(m[3]), m[4] === undefined ? Infinity : Number(m[4])];
}

// 설치 버전이 최신보다 낮으면 true. 판독 불가(형식 다름·빈값)는 false — 모르는 것을 구버전으로 지어내지 않는다.
export function isAgentOutdated(installed, latest = LATEST_AGENT_BUILD) {
    const a = parseBuild(installed);
    const b = parseBuild(latest);
    if (!a || !b) return false;
    for (let i = 0; i < 4; i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
    }
    return false;
}
